
import { mapGetters } from "vuex";

export default {
  name: "PainelGrupoAtalho",
  computed: {
    ...mapGetters(["currentUser", "empresaContexto", "features"]),
    visivel() {
      const admin = [true, 1, "1", "true"].includes(this.currentUser?.admin);

      return (
        admin &&
        this.empresaContexto?.tipo_grupo === "MATRIZ" &&
        Boolean(this.empresaContexto?.id_grupo_empresa) &&
        (this.features || []).includes("PLG_MULTIEMPRESA")
      );
    },
  },
};
